export const page_size = 9999;

export const extensionType = {
  LOCATIONS: 'location',
  ACTORS: 'actor',
  CREATORS: 'creator',
};

export const extensionRouteTypes = {
  LOCATIONS: 'locations',
  TALENTS: 'talents',
  CREATORS: 'creators',
};

export const types = {
  BOOKLET: 'booklet',
  ARCHIVE: 'archive',
  LOCATION: 'location',
  ACTOR: 'actor',
  CREATOR: 'creator',
  SCHEDULE: 'schedule',
  USER: 'user',
  SECTION: 'section',
};

export const DirectoryTreeTypes = {
  BOOKLETS: 'Booklets',
  ACTORS: 'Actors',
  LOCATIONS: 'Locations',
  CREATORS: 'Creators',
  USERS: 'Users',
  ROOT: 'root',
  MEDIA_HUB: 'MediaHub',
};

export const FragmentTypes = {
  ACTORS: 'actors',
  CALENDAR: 'calendar',
  CREATORS: 'creators',
  EXTENSION: 'extension',
  EXTENSION_COLLECTION: 'extension-collection',
  FILES_LIST: 'files-list',
  GALLERY: 'gallery',
  IMAGE: 'image',
  LOCATIONS: 'locations',
  MAP: 'map',
  MEDIA: 'media',
  PLACEHOLDER: 'placeholder',
  STORYBOARD: 'storyboard',
  TEXT: 'text',
  VIDEO: 'video',
};



// WEBPACK FOOTER //
// ./src/consts.js